import axios from 'axios';
import auth from '@/services/authSvc';
import router from '@/router/index';

/**
 * Single Patient Http Service
 * Used by singlePatient state store. This service is needed to sidestep mfa required
 * and provide more flexibility to catch errors
 */
export const HTTP = axios.create({
  baseURL: auth.getApiUrl(),
  headers: { Pragma: 'no-cache' }
});

HTTP.interceptors.request.use(function(config) {
  if (!auth.isLoggedIn()) {
    auth.returnToLogin();
    return Promise.reject(new Error('Not logged in'));
  }
  config.headers['x-session-token'] = auth.getToken();
  return config;
});

HTTP.interceptors.response.use((response) => {
  return response;
}, (e) => {
  router.push({ name: 'SinglePatientNotFound' });
  return e;
});

export default HTTP;
